<template>
    <div class="page-wrap">
        <div v-if="!showDel">
            <div class="top-card">
                <div class="input-group flex">
                    <div class="wrap flex">
                        <div class="label">任务名称：</div>
                        <div class="r-find">
                            <Input v-model="storePrams.title" placeholder="请输入任务名称" style="width: 250px"/>
                        </div>
                    </div>
                    <div class="wrap flex">
                        <div class="label">创建日期：</div>
                        <div class="r-find">
                            <DatePicker @on-change="changeTime" type="daterange" placement="bottom-end" placeholder="点击选择时间"
                                style="width: 250px"></DatePicker>
                        </div>
                    </div>
                    <div class="r-btn flex">
                        <Button  @click="searchList" type="primary">查询</Button>
                    </div>
                </div>
            </div>
            <div class="table_card">
                <Table :columns="columns" :data="data" :loading="loadingTab" >
                    <template slot-scope="{ row }" slot="operation">
                        <div class="flex-c">
                            <div class="table-btn del" @click="agree(row)">详情</div>
                            <div class="table-btn danger" @click="clearDel(row.id)">删除</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="allTime">
                        <div style="padding:10px 0">
                            <div>{{ row.start_time.split(' ')[0] }}</div>
                            <div>-</div>
                            <div>{{ row.end_time.split(' ')[0] }}</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="effectiveTime">
                        <div v-if="row.start_expired == null ||row.start_expired == undefined ||row.start_expired == '' || row.start_expired =='0000-00-00'">暂无日期</div>
                        <div v-else>
                            <div>{{ row.start_expired }}</div>
                            <div>-</div>
                            <div>{{ row.end_expired }}</div>
                        </div>
                    </template>                
                    <template slot-scope="{ row }" slot="allPerson">
                        <div>{{ row.completed_num }}/{{ row.support_num }}</div>
                    </template>
                    <template slot-scope="{row}" slot="is_requirement">
                        <div  v-if="row.requirement == 0" >个人</div>
                        <div  v-if="row.requirement == 1" >企业</div>
                        <div  v-if="row.requirement == 2" >个人、企业</div>
                    </template>
                    <template slot-scope="{row}" slot="is_sms">
                        <div  v-if=" row.smsStatus == 1"  style="color:#54CDC9" >启用</div>
                        <div  v-else >未启用</div>
                    </template>
                    <template slot-scope="{row}" slot="sign_status">
                        <div v-if=" row.is_nail_sign == 1" class="table-link">已签署</div>
                        <div v-else class="table-link" style="color:#ff0000">未签署</div>
                    </template>
                    <template slot-scope="{row}" slot="support_yinzhang">
                        <div v-if=" row.support_yinzhang == 1"  style="color:#54CDC9">启用</div>
                        <div v-else class="table-link">未启用</div>
                    </template>
                    <template slot-scope="{row}" slot="showBtn">
                        <div class="flex-c">
                            <div class="table-btn del" @click="seePic(row)">查看</div>
                        </div>
                    </template>
                </Table>
                <Page :total="storePrams.total"
                    :current="storePrams.page"
                    style="text-align:right;margin-top: 20px"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                    :page-size="storePrams.limit"/>
            </div>
        </div>
        <div v-if="seeCard">
            <div class="pop"></div>
            <div class="pop-card fixed flex-c">
                <div class="l-pop-del">
                    <div class="pop-pic">
                        <img :src="leftImg"/>
                    </div>
                    <div class="pop-word">参与扫码签署</div>
                </div>
                <div class="r-pop-del">
                    <div class="pop-pic">
                        <img :src="rightImg"/>
                    </div>
                    <div class="pop-word">其他人扫码签署</div>
                </div>
                <!-- <Button>刷新二维码</Button> -->
                <div style="width:80px">
                    <Button  @click="getNewIMG()"  type="primary">刷新</Button>
                </div>
                <div class="pos-btn flex-c" @click="seeCard = false">关闭</div>
            </div>
        </div>
        <div v-if="seeTable">
            <div class="pop"></div>        
            <div class="pop-table fixed">    
                <div class="contxq">合同详情</div>
                <div style="padding:24px;padding-top:0px;">
                    <div class="search-group flex">
                        <div class="wrap flex">
                            <div class="label">任务名称：</div>
                            <div class="r-find">
                            <Input v-model="elsePrams.title" placeholder="请输入任务名称" style="width: 240px"/>
                            </div>
                        </div>
                        <div class="r-btn flex" style="margin-left:12px">
                            <Button  @click="getDetail" type="primary">查询</Button>
                            <!-- downloadSelectedDetail --> 
                            <Button
                                v-if="isPlatform208"
                                style="margin-left:12px"
                                :loading="downloadingDetail"
                                :disabled="!canDownloadDetail || downloadingDetail"
                                @click="downloadSelectedDetail"
                            >
                                {{ downloadingDetail ? '下载中...' : '批量下载' }}
                            </Button> 
                        </div> 
                    </div>
                    <div v-if="isPlatform208">
                        <Alert type="warning" show-icon style="margin-top: 12px;width: 430px;" >注：批量下载功能一份合同24小时内只允许下载一次！</Alert>
                    </div>
                    <div style="max-height: 400px;overflow-y: auto;">
                        <Table :columns="detailColumns" :data="dataTable" :loading="loadingTabA" row-key="id">
                            <template slot-scope="{row}" slot="operation" >
                                <div class="table-link" @click="seeContractDel(row)">查看</div>
                            </template>
                            <template slot-scope="{row}" slot="name">
                                <div>{{ row.part.name }}</div>
                            </template>
                            <template slot-scope="{row}" slot="phone">
                                <div >{{ row.part.phone }}</div>
                            </template>
                        </Table>
                    </div>
                    <Page :total="elsePrams.total"
                        :current="elsePrams.page"
                        style="text-align:right;margin-top: 20px"
                        show-elevator
                        show-total
                        @on-change="pageChanges"
                        :page-size="elsePrams.limit"/>
                </div>                
                <div class="close-icon" @click="seeTable = false">
                    <Icon type="md-close" size="24"/>
                </div>
            </div>
        </div>
        <detail ref="contractDel" @goBack="showSelf"></detail>
    </div>
</template>

<script>
import detail from './components/contractDel'
import { batchList, batchDetails , delBatch, add_new_code, getpdf, batchDownloadToZip } from '../../api/interFace'
export default {
    name: "contract",
    components:{
        detail
    },
    data() {
        return {
            fromVal: {
                contract_name: '',
                start_time: '',
                end_time: '',
            },
            loadingTab:false,
            loadingTabA:false,
            // 合同详情弹窗：勾选下载
            selectedDetailRows: [],
            downloadingDetail: false,
            columns: [
                {
                    title: '#',
                    align: 'center',
                    width: 120,
                    key: 'id'
                },
                {
                    title: '任务名称',
                    align: 'center',
                    width: 200,
                    key: 'task_name'
                },
                {
                    title: '签约截止日期',
                    align: 'center',
                    slot: 'allTime',
                    width:120
                },
                {
                    title: '合同有效日期',
                    align: 'center',
                    slot: 'effectiveTime',
                    width:180
                },
                {
                    title: '二维码',
                    key: 'address',
                    align: 'center',
                    width: 100,
                    slot: 'showBtn'
                },
                {
                    title: '参与人数',
                    slot: 'allPerson',
                    width: 100,
                    align: 'center'
                },
                {
                    title: '创建日期',
                    align: 'center',
                    width: 180,
                    key: 'created_at'
                },
                {
                    title: '甲方状态',
                    key: 'action',
                    width: 100,
                    align: 'center',
                    slot: 'sign_status'
                },
                {
                    title: '签署者类型',
                    key: 'action',
                    width: 120,
                    align: 'center',
                    slot: 'is_requirement'
                },
                {
                    title: '短信验证',
                    key: 'action',
                    width: 100,
                    align: 'center',
                    slot: 'is_sms'
                },
                {
                    title: '企业印章',
                    key: 'action',
                    width: 100,
                    align: 'center',
                    slot: 'support_yinzhang'
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 210,
                    align: 'center',
                    fixed: 'right',
                    slot: 'operation'
                }
            ],
            data: [],
            columnTable: [
                {
                    title: '合同ID',
                    align: 'center',
                    width: 120,
                    key: 'id'
                },
                {
                    title: '签署者',
                    align: 'center',
                    slot: 'name'
                },
                {
                    title: '手机号',
                    align: 'center',
                    slot: 'phone',
                },
                {
                    title: '签署详情',
                    align: 'center',
                    // width: 120,
                    key: 'sign_time'
                },
                {
                    title: '合同详情',
                    key: 'action',
                    align: 'center',
                    slot: 'operation'
                }
            ],
            dataTable: [],
            showDel: false,
            seeCard: false,
            new_batch_id:'',
            seeTable: false,
            leftImg:'',
            rightImg:'',
            storePrams: {
                limit: 10,
                page: 1,
                total: 0,
                start_time: '',
                end_time: '',
                title: ''
            },
            elsePrams: {
                limit: 10,
                page: 1,
                total: 0,
                title: '',
                batch_id: '',
            },
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo || {}
        },
        isPlatform208() {
            // 208 HSE管理档案
            return Number(this.$store.state.userInfo.uniacid_id) === 208
        },
        detailColumns() {
            const base = this.columnTable || []
            if (!this.isPlatform208) return base
            return [
                {
                    title: '',
                    width: 60,
                    align: 'center',
                    renderHeader: (h) => {
                        const list = this._detailEligibleRows()
                        const checkedCount = this._detailCheckedEligibleCount()
                        const allChecked = list.length > 0 && checkedCount === list.length
                        const indeterminate = checkedCount > 0 && checkedCount < list.length
                        return h('Checkbox', {
                            props: {
                                value: allChecked,
                                indeterminate,
                                disabled: list.length === 0
                            },
                            on: {
                                'on-change': (val) => {
                                    this.selectedDetailRows = val ? list.slice() : []
                                }
                            }
                        }, '')
                    },
                    render: (h, { row }) => {
                        // is_download: 1 已下载（不可再勾选），0 未下载
                        // sign_time: 0 未签署（不可再勾选）
                        const disabled =
                            Number(row && row.is_download) === 1 ||
                            Number(row && row.sign_time) === 0
                        const id = row && row.id
                        const checked = !!id && (this.selectedDetailRows || []).some(r => r && r.id === id)
                        return h('Checkbox', {
                            props: { value: checked, disabled },
                            on: {
                                'on-change': (val) => {
                                    if (!id) return
                                    const next = new Map()
                                    ;(this.selectedDetailRows || []).forEach(r => {
                                        if (r && r.id) next.set(r.id, r)
                                    })
                                    if (val) next.set(id, row)
                                    else next.delete(id)
                                    this.selectedDetailRows = Array.from(next.values())
                                }
                            }
                        })
                    }
                },
                ...base
            ]
        },
        canDownloadDetail() {
            return this.isPlatform208 && this.selectedDetailRows && this.selectedDetailRows.length > 0
        }
    },
    created() {
        this.$store.commit('changePollingSpin', false)
        // 208 平台：分页单页数量 20
        if (this.isPlatform208) {
            // this.storePrams.limit = 20
            this.elsePrams.limit = 20
        }
        this.getList()
    },
    mounted() {
    },
    methods: {
        _detailEligibleRows() {
            // 仅“未下载”且“已签署( sign_time != 0 )”的允许勾选
            const list = this.dataTable || []
            return list.filter(r => {
                if (Number(r && r.is_download) === 1) return false
                if (Number(r && r.sign_time) === 0) return false
                return true
            })
        },
        _detailCheckedEligibleCount() {
            const eligibleIds = new Set((this._detailEligibleRows() || []).map(r => r && r.id).filter(Boolean))
            return (this.selectedDetailRows || []).filter(r => r && eligibleIds.has(r.id)).length
        },
        _formatDateYMD(date = new Date()) {
            const d = date instanceof Date ? date : new Date(date)
            const y = d.getFullYear()
            const m = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()).padStart(2, '0')
            return `${y}-${m}-${day}`
        },
        _parseFilenameFromDisposition(disposition) {
            if (!disposition) return ''
            // Content-Disposition: attachment; filename="xxx.zip"; filename*=UTF-8''xxx.zip
            const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
            if (utf8Match && utf8Match[1]) {
                try { return decodeURIComponent(utf8Match[1].replace(/"/g, '')) } catch (e) { /* ignore decode error */ }
                return utf8Match[1].replace(/"/g, '')
            }
            const match = disposition.match(/filename\s*=\s*("?)([^";]+)\1/i)
            return match && match[2] ? match[2] : ''
        },
        _downloadBlob(blob, filename) {
            const name = filename || `contracts_${Date.now()}.zip`
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = name
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)
        },
        searchList(){
            this.storePrams.page = 1
            this.getList()
        },    
        getList() {
            this.loadingTab = true
            batchList(this.storePrams).then(res => {
                this.loadingTab = false
                this.data = res.data.data || []
                this.storePrams.total = res.data.total
            }).catch(res => {
                this.loadingTab = false
                console.log(res)
            })
        },
        getNewIMG(){
            add_new_code({batch_id:this.new_batch_id}).then(res => {
                this.$Message.success('刷新成功')
                this.getList()
                this.new_batch_id = res.data.batch_id
                this.leftImg = res.data.firstparty_url
                this.rightImg = res.data.partyb_url
                // this.seeCard = false
            }).catch(res => {
                console.log(res)
            })
        },
        seeContractDel(row){
            this.$router.push({ path: '/management/contract',query: row})  
        },
        pageChange(index) {
            this.storePrams.page = index
            this.getList()
        },
        agree(e) {
            this.elsePrams.batch_id = e.id
            this.elsePrams.page = 1
            this.searchMore()
        },
        getDetail(){
            this.elsePrams.page = 1
            this.searchMore()
        },
        searchMore(){
            this.loadingTabA = true
            // 列表刷新时清空勾选，避免旧选中影响下载按钮状态
            this.selectedDetailRows = []
            batchDetails(this.elsePrams).then(res => {
                this.loadingTabA = false
                this.seeTable = true
                this.dataTable = res.data.data || []
                this.elsePrams.total = res.data.total
            }).catch(res=>{
                this.loadingTabA = false
                this.$Message.error(res.msg)
            })
        },
        changeTime(e) {
            this.storePrams.start_time = e[0]
            this.storePrams.end_time = e[1]
        },
        seePic(row){
            this.seeCard = true
            this.leftImg=row.firstparty_code_url
            this.rightImg=row.partyb_code_url
            this.new_batch_id = row.id
            console.log(row)
        },
        showSelf(){
            this.showDel = false
        },
        clearDel(id) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '请问您是否确认删除此条签署任务，删除后无法恢复!!!',
                onOk: () => {
                    delBatch({batch_id:id}).then(res=>{
                        this.$Message.success(res.msg)
                        this.getList()
                    }).catch(res=>{
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        pageChanges(index) {
            this.elsePrams.page = index
            this.searchMore()
        },
        // iView Table 的内置 selection 列不支持 Element 的 selectable，这里改成自定义 Checkbox 列后不再依赖 on-selection-change
        
        async downloadSelectedDetail() { 
            if (this.downloadingDetail) return
            if (!this.canDownloadDetail) return 
            const list = this.selectedDetailRows.slice() 
            this.downloadingDetail = true
            const closeMsg = this.$Message.loading({
                content: '正在下载，请稍后...',
                duration: 0
            })
            try {
                const contractIds = (list || []).map(i => i && i.id).filter(Boolean).join(',')
                if (!contractIds) return
                const res = await batchDownloadToZip({ contract_ids: contractIds,type:2 }) 
                const blob = res && res.data
                const headers = (res && res.headers) || {}
                const contentType = (headers['content-type'] || headers['Content-Type'] || '').toLowerCase()

                // 如果后端异常时仍返回 JSON，这里把错误信息读出来提示，并走兜底
                if (contentType.includes('application/json') || contentType.includes('text/plain')) {
                    const text = await new Promise(resolve => {
                        try {
                            const reader = new FileReader()
                            reader.onload = () => resolve(reader.result || '')
                            reader.onerror = () => resolve('')
                            reader.readAsText(blob)
                        } catch (e) {
                            resolve('')
                        }
                    })
                    let msg = '下载失败'
                    try {
                        const json = JSON.parse(text || '{}')
                        msg = (json && (json.msg || json.message)) || msg
                    } catch (e) {
                        msg = text || msg
                    }
                    this.$Message.error(msg)
                    throw new Error(msg)
                }

                // 优先使用后端返回的文件名；否则：日期 + 合同文件包.zip（如：2026-03-11合同文件包.zip）
                const headerFilename = this._parseFilenameFromDisposition(headers['content-disposition'] || headers['Content-Disposition'])
                const filename = headerFilename || `${this._formatDateYMD()}批签合同文件包.zip`
                this._downloadBlob(blob, filename)

                // 下载成功后：清空选中并刷新列表（后端会返回 is_download 更新为 1）
                this.selectedDetailRows = []
                this.searchMore()
                return
            } catch (e) {
                // 失败则兜底：逐个打开下载链接（无后端打包接口/浏览器限制时可用）
            } finally {
                this.downloadingDetail = false
                if (typeof closeMsg === 'function') closeMsg()
            }

            if (list.length > 10) {
                this.$Modal.confirm({
                    title: '下载提示',
                    content: `<p>当前勾选 <b>${list.length}</b> 份合同，将会打开多个下载窗口，是否继续？</p>`,
                    onOk: () => this._downloadDetailList(list),
                    onCancel: () => {}
                })
            } else {
                this._downloadDetailList(list)
            }

            // 兜底下载同样视为“已发起下载”：清空选中并刷新列表
            this.selectedDetailRows = []
            this.searchMore()
        },
        _downloadDetailList(list) {
            // iView/浏览器可能限制连续 window.open，这里加一点点间隔
            const next = (idx) => {
                if (idx >= list.length) return
                const e = list[idx] || {}
                if (e.contract_path) {
                    window.open(e.contract_path)
                    setTimeout(() => next(idx + 1), 150)
                } else if (e.id) {
                    getpdf({ id: e.id }).then(res => {
                        window.open(res.data)
                        setTimeout(() => next(idx + 1), 150)
                    }).catch(res => {
                        this.$Message.error(res.msg || '下载失败')
                        setTimeout(() => next(idx + 1), 150)
                    })
                } else {
                    setTimeout(() => next(idx + 1), 150)
                }
            }
            next(0)
        }
    }
}
</script>

<style scoped lang="scss">
.page-wrap {  
    .top-card {
        width: 100%;
        background: #FFFFFF;        
        border-radius: 8px;
        padding: 20px 20px;
        box-sizing: border-box;
        .input-group {
            .wrap {
                margin-right: 25px;
            }
            .label {
                font-size: 14px;
                color: #545F78;                
            }
            .r-btn {
                .s-btn {
                    width: 78px;
                    height: 30px;
                    background: #4877E8;
                    border-radius: 15px;
                    font-size: 12px;
                    font-weight: bold;
                    color: #FFFFFF;
                    cursor: pointer;
                    margin-right: 20px;
                    &:hover {
                        opacity: .4;
                    }
                }                
            }
        }
    }
    .table_card {
        width: 100%;
        min-height: 700px;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 20px 20px;
        box-sizing: border-box;
        margin-top: 20px;
    }
    .pop-card {
        width: 712px;
        height: 420px;
        background: #FFFFFF;
        border-radius: 5px;
        z-index: 999;
        .l-pop-del, .r-pop-del {
            display: flex;
            flex-direction: column;
            flex: 1;
            align-items: center;
            justify-content: center;
        }
        .pop-pic {
            width: 180px;
            height: 180px;
            border-radius: 6px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 6px;
            }
        }
        .pop-word {
            font-size: 16px;
            color: #191A1F;
            margin-top: 20px;
        }
        .pos-btn {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 30px;
            width: 88px;
            height: 34px;
            background: #FFFFFF;
            font-weight: bold;
            border: 1px solid #DBDEE6;
            border-radius: 6px;
            cursor: pointer;
            color: #191A1F;
            &:hover {
                box-shadow: 0px 4px 5px 2px rgba(0, 0, 0, 0.1);
            }
        }
    }
    .pop-table {
        width: 900px;
        background: #FFFFFF;
        border-radius: 5px;
        box-sizing: border-box;
        z-index: 999;
        .search-group {
            margin-bottom: 20px;
            .wrap {
                .label {
                    font-size: 14px;
                    color: #545F78;
                }
            }
            .s-btn {
                width: 78px;
                height: 30px;
                background: #4877E8;
                border-radius: 15px;
                font-size: 12px;
                font-weight: bold;
                color: #FFFFFF;
                cursor: pointer;
                margin-right: 20px;
                margin-left: 20px;
                &:hover {
                    opacity: 0.4;
                }
            }
        }

        .table-link {
            font-size: 15px;
            font-weight: bold;
            color: #4877E8;
            cursor: pointer;
            &:hover{
                text-decoration: underline;
            }
        }
        .close-icon {
            position: absolute;
            top: 15px;
            right: 15px;
            font-size: 10px;
            cursor: pointer;
        }
        .contxq {
            font-size: 16px;
            margin-top: 16px;
            // margin-left: 16px;
            margin-bottom: 16px;
            font-weight: 500;
            color:#17233d;
            padding-left: 16px;
            padding-bottom: 8px;
            border-bottom:1px solid #e8eaec;
        }
    }
}

</style>
